export default {
  CanalPlus: '/assets/images/logos/providers/logo-canalplus.jpg',
  CMStarTimes: '/assets/images/logos/providers/logo-cmstartimes.jpg',
  CMEASYTV: '/assets/images/logos/providers/logo-easytv.jpg',
  NGDSTV: '/assets/images/logos/providers/logo-dstv.png',
  NGBAXI: '/assets/images/logos/providers/logo-dstv.png',
  MTN: '/assets/images/logos/providers/logo-momo.jpg',
  ORANGE: '/assets/images/logos/providers/logo-orange-money.jpg',
  CAMTEL: '/assets/images/logos/providers/logo-camtel.jpg',
  NEXTTEL: '/assets/images/logos/providers/logo-nexttel.jpg',
  YOOMEE: '/assets/images/logos/providers/logo-yoomee.jpg',
  ENEO: '/assets/images/logos/providers/logo-eneo.png',
  HALOTEL: '/assets/images/logos/providers/logo-halotel.png',
  MPESA: '/assets/images/logos/providers/logo-mpesa.png',
  TNM: '/assets/images/logos/providers/logo-tnm.png',
  VODACOM: '/assets/images/logos/providers/logo-vodacom.png',
  WAVE: '/assets/images/logos/providers/logo-wave.jpg',
  YAS: '/assets/images/logos/providers/logo-yas.png',
  AIRTEL: '/assets/images/logos/providers/logo-airtelmoney.jpg',
  ZAMTEL: '/assets/images/logos/providers/logo-zamtel.png',
  MOOV: '/assets/images/logos/providers/logo-moov.png',
  CAMWATER: '/assets/images/logos/providers/logo-camwater.png',
  MESOMB: '/assets/images/logos/providers/logo-mesomb.png',
} as Record<string, string>;
